
import { Link } from "react-router-dom";
import Slider from "react-slick";
import React from 'react';

export default function HomeSolutions() {
  const services = [
    {
      img: "/assets/images/solution-image1.webp",
      title: "Digital Services",
      link:"/omnichannel-ecommerce-logistics-solution",
    },
    {
      img: "/assets/images/solution-image2.webp",
      title: "Transport",
         link:"/transportation-distribution",
    },
    {
      img: "/assets/images/solution-image3.webp",
      title: "Contract Logistics",
      link:"/supply-chain-management",
    },
    {
      img: "/assets/images/solution-image-new4.webp",
      title: "Become one of us",
        link:"/career",
    },
    {
      img: "/assets/images/solution-image-new5.webp",
      title: "Get to know us",
      link:"/contact-us",
    },
  ];


    const settings = {
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    arrows: true,
    speed: 1300,
    cssEase: "ease",
    prevArrow: (
      <button className="slick-arrow slick-prev" aria-label="Previous Slide">
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    ),
    nextArrow: (
      <button className="slick-arrow slick-next" aria-label="Next Slide">
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    ),
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (

    <>

    <section className="service-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12">
            <div className="heading-text">
              <h4 className="heading">Our Smart Solutions</h4>
            </div>
          </div>
        </div>
      </div>

      <div className="service-section">
        <Slider {...settings} className="service-slider">
          {services.map((service, index) => (
            <div className="service-col" key={index}>
              <div className="service-inner">
                <div className="image">
                  <img
                    className="img-responsive"
                    src={service.img}
                    loading="lazy"
                    alt={service.title}
                  />
                </div>
                <div className="content">
                  <div className="title">{service.title}</div>
                  <Link to={service.link} className="start-here">
                    Start Here
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
    
    </>
  
  )
}



